export const ExpandIcon = ({ className, size = 24 }: { className?: string; size?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={size}
      height={size}
      viewBox="0 0 256 256"
      className={className}
    >
      <g
        style={{
          stroke: 'none',
          strokeWidth: 0,
          strokeDasharray: 'none',
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 10,
          fill: 'none',
          fillRule: 'nonzero',
          opacity: 1,
        }}
        transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
      >
        <path
          d="M 74.461 17.107 c -0.012 -0.059 -0.034 -0.114 -0.051 -0.171 c -0.02 -0.068 -0.036 -0.136 -0.063 -0.202 c -0.028 -0.067 -0.066 -0.128 -0.101 -0.192 c -0.028 -0.051 -0.05 -0.104 -0.083 -0.153 c -0.147 -0.219 -0.335 -0.408 -0.555 -0.554 c -0.047 -0.032 -0.099 -0.053 -0.148 -0.081 c -0.065 -0.036 -0.127 -0.075 -0.196 -0.103 c -0.065 -0.027 -0.133 -0.042 -0.2 -0.062 c -0.058 -0.017 -0.113 -0.039 -0.173 -0.051 c -0.129 -0.026 -0.26 -0.039 -0.392 -0.039 H 53.546 c -1.104 0 -2 0.896 -2 2 s 0.896 2 2 2 h 14.127 L 41.524 45.647 c -0.781 0.781 -0.781 2.047 0 2.828 c 0.39 0.391 0.902 0.586 1.414 0.586 s 1.024 -0.195 1.414 -0.586 l 26.148 -26.148 v 14.127 c 0 1.104 0.896 2 2 2 s 2 -0.896 2 -2 V 17.499 C 74.501 17.368 74.487 17.237 74.461 17.107 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 35.497 90 H 2 c -1.104 0 -2 -0.896 -2 -2 V 54.503 c 0 -1.104 0.896 -2 2 -2 h 33.497 c 1.104 0 2 0.896 2 2 V 88 C 37.497 89.104 36.601 90 35.497 90 z M 4 86 h 29.497 V 56.503 H 4 V 86 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 2 43.799 c -1.104 0 -2 -0.896 -2 -2 v -6 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 6 C 4 42.903 3.104 43.799 2 43.799 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 2 28.533 c -1.104 0 -2 -0.896 -2 -2 v -9.266 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 9.266 C 4 27.637 3.104 28.533 2 28.533 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 2 10 c -1.104 0 -2 -0.896 -2 -2 V 2 c 0 -1.104 0.896 -2 2 -2 h 6 c 1.104 0 2 0.896 2 2 S 9.104 4 8 4 H 4 v 4 C 4 9.104 3.104 10 2 10 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 71.429 4 H 60.857 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 10.571 c 1.104 0 2 0.896 2 2 S 72.533 4 71.429 4 z M 50.285 4 H 39.714 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 10.571 c 1.104 0 2 0.896 2 2 S 51.39 4 50.285 4 z M 29.143 4 H 18.571 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 10.571 c 1.104 0 2 0.896 2 2 S 30.247 4 29.143 4 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 88 10 c -1.104 0 -2 -0.896 -2 -2 V 4 h -4 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 6 c 1.104 0 2 0.896 2 2 v 6 C 90 9.104 89.104 10 88 10 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 88 73.429 c -1.104 0 -2 -0.896 -2 -2 V 60.857 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 10.571 C 90 72.533 89.104 73.429 88 73.429 z M 88 52.285 c -1.104 0 -2 -0.896 -2 -2 V 39.714 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 10.571 C 90 51.39 89.104 52.285 88 52.285 z M 88 31.143 c -1.104 0 -2 -0.896 -2 -2 V 18.571 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 10.571 C 90 30.247 89.104 31.143 88 31.143 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 88 90 h -6 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 4 v -4 c 0 -1.104 0.896 -2 2 -2 s 2 0.896 2 2 v 6 C 90 89.104 89.104 90 88 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 72.733 90 h -9.267 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 9.267 c 1.104 0 2 0.896 2 2 S 73.838 90 72.733 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
        <path
          d="M 54.201 90 h -6 c -1.104 0 -2 -0.896 -2 -2 s 0.896 -2 2 -2 h 6 c 1.104 0 2 0.896 2 2 S 55.306 90 54.201 90 z"
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeLinejoin: 'miter',
            strokeMiterlimit: 10,
            fillRule: 'nonzero',
            opacity: 1,
          }}
          transform=" matrix(1 0 0 1 0 0) "
          strokeLinecap="round"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
